export default {"src":"/assets/turbo/929e56e7/ottoversandat/_next/static/media/favicon.7395fa3b.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};